import { useQuery } from '@apollo/client';

import { GetArticleLikes, GetMediaLikes } from '../../api/queries/likes.gql';

function getLikeQuery(contentType) {
  return contentType === 'article' ? GetArticleLikes : GetMediaLikes;
}

function getLikeQueryVariables(contentType, id, brandSlug, slug) {
  if (contentType === 'article') {
    return {
      brandSlug,
      slug,
    };
  }

  return {
    brandSlug,
    id,
  };
}

export function useContentLikes({ brandSlug, contentType, id, slug }) {
  const { loading, error, data } = useQuery(getLikeQuery(contentType), {
    variables: getLikeQueryVariables(contentType, id, brandSlug, slug),
  });
  const count = data?.brand?.[contentType]?.likes;

  return {
    count,
    isReady: count !== undefined && !loading && !error,
  };
}
